import MenuDashboard, { Paginas } from "../../../components/MenuDashboard";
import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import IconButton from "@mui/material/IconButton";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import {
  Button,
  Box,
  Divider,
  Typography,
  Card,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { Titulo, Subtitulo } from "../../../components";
import useStyles from "./styles";
import ShareIcon from "@mui/icons-material/Share";
import imgTwitter from "../../../assets/images/twitter.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CelebrationIcon from "@mui/icons-material/Celebration";
import LinkIcon from "@mui/icons-material/Link";

import { configurationVariables } from "../../../environment";

import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
} from "react-share";

import { Modal } from "../../../components";
import useAlert from "../../../hooks/useAlert";

export function ConvidarAmigos() {
  const classes = useStyles();
  const theme = useTheme();

  const [showModal, setShowModal] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const { showAlertError, showAlertInfo } = useAlert();

  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  const handlerOpenModal = (event) => {
    event.preventDefault();
    setShowModal(!showModal);
  };

  const handlerCloseModal = (event) => {
    event.preventDefault();
    setShowModal(false);
  };

  const handleCopyClick = () => {
    copyTextToClipboard(configurationVariables.UrlLoja)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
        showAlertInfo(
          `Link copiado com sucesso! Agora você pode compartilhar.`
        );
      })
      .catch((err) => {
        showAlertError("Ops! Não foi possível copiar o link. Tente novamente.");
        console.error(err);
      });
  };

  return (
    <MenuDashboard pagina={Paginas.AlterarSenha}>
      <Grid container justifyContent="center" sx={{ pt: 8, pb: 4 }}>
        <Grid item xs={12} lg={8} xl={6}>
          <Card
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: 3,
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              background: "linear-gradient(to bottom, #ffffff, #f8f9fa)",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ textAlign: "center", mb: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 70,
                  height: 70,
                  borderRadius: "50%",
                  backgroundColor: theme.palette.primary.light,
                  color: "white",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <CelebrationIcon sx={{ fontSize: 32 }} />
              </Box>
              <Titulo
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: 24, md: 28 },
                  color: theme.palette.primary.main,
                  mb: 1,
                }}
              >
                Compartilhe com amigos
              </Titulo>
              <Subtitulo
                sx={{
                  fontSize: "1rem",
                  color: theme.palette.text.secondary,
                  maxWidth: 500,
                  mx: "auto",
                }}
              >
                Indique nossa plataforma e ajude seus amigos a realizar
                operações online de forma simples e segura.
              </Subtitulo>
            </Box>

            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <LinkIcon
                  sx={{
                    mr: 1,
                    color: theme.palette.primary.main,
                    fontSize: 20,
                  }}
                />
                <Subtitulo
                  sx={{ fontWeight: 600, color: theme.palette.text.primary }}
                >
                  Seu link de convite
                </Subtitulo>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TextField
                  spellCheck="false"
                  fullWidth
                  variant="outlined"
                  readOnly
                  value={configurationVariables.UrlLoja}
                  // Esta é a solução para manter a borda completa
                  InputLabelProps={{ shrink: true }}
                  // Personalização adicional para melhor aparência
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: 2,
                      padding: "4px 12px",
                      "&:hover": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.primary.main,
                        },
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "12px 0",
                      color: theme.palette.text.primary,
                      fontSize: "0.95rem",
                    },
                  }}
                  // Adicionando um placeholder invisível para garantir a altura consistente
                  label=" "
                  InputProps={{
                    startAdornment: (
                      <LinkIcon
                        sx={{
                          mr: 1,
                          color: theme.palette.primary.main,
                          opacity: 0.7,
                        }}
                      />
                    ),
                  }}
                />

                <Button
                  variant={isCopied ? "contained" : "outlined"}
                  color={isCopied ? "success" : "primary"}
                  onClick={handleCopyClick}
                  sx={{
                    minWidth: { xs: "100%", sm: "140px" },
                    height: "56px",
                    borderRadius: 2,
                    textTransform: "capitalize",
                    fontWeight: 600,
                    transition: "all 0.2s ease",
                    boxShadow: isCopied
                      ? "0 4px 12px rgba(76, 175, 80, 0.3)"
                      : "none",
                  }}
                >
                  <ContentCopyIcon fontSize="small" sx={{ mr: 1 }} />
                  {isCopied ? "Copiado!" : "Copiar"}
                </Button>
              </Box>
            </Box>

            <Box sx={{ textAlign: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handlerOpenModal}
                sx={{
                  minWidth: "260px",
                  py: 1.5,
                  color: "white",
                  borderRadius: 2,
                  textTransform: "capitalize",
                  fontWeight: 600,
                  boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                  },
                }}
              >
                <ShareIcon sx={{ mr: 1.5 }} />
                Compartilhar nas redes
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>

      <Modal
        show={showModal}
        hasButtonClose={true}
        close={() => setShowModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{ p: 3 }}>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Titulo
              sx={{
                fontWeight: "bold",
                fontSize: 22,
                color: theme.palette.primary.main,
              }}
            >
              Compartilhar convite
            </Titulo>
            <Subtitulo sx={{ color: theme.palette.text.secondary, mt: 1 }}>
              Escolha como deseja compartilhar
            </Subtitulo>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <List sx={{ width: "100%", p: 0 }}>
            <FacebookShareButton
              url={configurationVariables.UrlLoja}
              quote={"Venha conhecer a plataforma"}
              hashtag="#LojaVirtualdeCambio"
              style={{ width: "100%" }}
            >
              <ListItem
                sx={{
                  py: 2,
                  borderRadius: 2,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#f5f7fa",
                    transform: "translateX(4px)",
                  },
                }}
                secondaryAction={
                  <IconButton edge="end">
                    <KeyboardArrowRightOutlinedIcon />
                  </IconButton>
                }
              >
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      background: "linear-gradient(135deg, #3b5998, #4c70ba)",
                      color: "white",
                    }}
                  >
                    <FacebookOutlinedIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                      Compartilhar no Facebook
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      Poste em sua linha do tempo
                    </Typography>
                  }
                />
              </ListItem>
            </FacebookShareButton>

            <TwitterShareButton
              url={configurationVariables.UrlLoja}
              quote={"Venha conhecer a plataforma"}
              hashtag="#LojaVirtualdeCambio"
              style={{ width: "100%" }}
            >
              <ListItem
                sx={{
                  py: 2,
                  borderRadius: 2,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#f5f7fa",
                    transform: "translateX(4px)",
                  },
                }}
                secondaryAction={
                  <IconButton edge="end">
                    <KeyboardArrowRightOutlinedIcon />
                  </IconButton>
                }
              >
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      background: "linear-gradient(135deg, #1da1f2, #0d8bd9)",
                      color: "white",
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        width: "22px",
                        height: "22px",
                        filter: "brightness(0) invert(1)",
                      }}
                      src={imgTwitter}
                      alt="Twitter"
                    />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                      Compartilhar no Twitter
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      Poste em seu feed
                    </Typography>
                  }
                />
              </ListItem>
            </TwitterShareButton>

            <WhatsappShareButton
              url={configurationVariables.UrlLoja}
              title="Faça seu cadastro em nossa plataforma"
              style={{ width: "100%" }}
            >
              <ListItem
                sx={{
                  py: 2,
                  borderRadius: 2,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#f5f7fa",
                    transform: "translateX(4px)",
                  },
                }}
                secondaryAction={
                  <IconButton edge="end">
                    <KeyboardArrowRightOutlinedIcon />
                  </IconButton>
                }
              >
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      background: "linear-gradient(135deg, #25d366, #128c7e)",
                      color: "white",
                    }}
                  >
                    <WhatsAppIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                      Enviar pelo WhatsApp
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      Compartilhe com seus contatos
                    </Typography>
                  }
                />
              </ListItem>
            </WhatsappShareButton>
          </List>

          <Divider sx={{ mt: 2, mb: 3 }} />

          <Button
            variant="outlined"
            fullWidth
            onClick={handlerCloseModal}
            sx={{
              py: 1.5,
              borderRadius: 2,
              textTransform: "capitalize",
              fontWeight: 600,
            }}
          >
            Voltar
          </Button>
        </Box>
      </Modal>
    </MenuDashboard>
  );
}
